import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import formatTitle from "../common/formatTitle";
import { Button } from "gatsby-material-ui-components";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Img from "gatsby-image";
import TitreTexteCta from "../common/TitreTexteCta";

const useStyles = makeStyles((theme) => ({
  firstRow: {
    padding: "10em 10% 7% 10%",
  },
  firstRowMobile: {
    padding: "3em 5% 7% 5%",
    zIndex: 1100,
  },
  noMargin: {
    margin: 0,
  },
  enLight: {
    color: theme.palette.primary.light,
  },
  parag: {
    maxWidth: "80%",
  },
  rounded: {
    borderRadius: 10,
  },
}));

const ourMission = ({ image, langKey, title, content, btnLabel }) => {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("lg"));
  return (
    <Grid
      item
      container
      direction={matches ? "row" : "column-reverse"}
      alignItems="center"
      justify="space-between"
      spacing={matches ? 4 : 0}
      className={clsx({
        [classes.firstRow]: matches,
        [classes.firstRowMobile]: !matches,
      })}
    >
      <TitreTexteCta
        title={formatTitle(title)}
        text={content}
        buttonLabel={btnLabel}
        ctaUrl={`/${langKey}/contact`}
        xs={12}
        lg={5}
      />
      {matches && (
        <Grid item xs={12} lg={6}>
          <Img fluid={image} width="60%" fadeIn className={classes.rounded} />
        </Grid>
      )}
    </Grid>
  );
};

ourMission.propTypes = {
  image: PropTypes.object.isRequired,
};

export default ourMission;
